// // src/pages/Quotation/QuotationList.jsx

// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Paper,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Chip,
//   Button,
//   TextField,
//   InputAdornment,
//   Stack,
//   CircularProgress,
//   IconButton,
//   Tooltip,
// } from "@mui/material";
// import { Search, Download, Visibility, History, RequestQuote } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// const API_URL = "http://api.onedesk.digital/api";

// export default function QuotationList() {
//   const [quotations, setQuotations] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");
//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchQuotations();
//   }, []);

//   const fetchQuotations = async () => {
//     try {
//       const res = await axios.get(`${API_URL}/quotations`);
//       setQuotations(res.data.quotations || []);
//     } catch (err) {
//       alert("Failed to load quotations");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const filtered = quotations.filter(q =>
//     q.quotation_no.toLowerCase().includes(search.toLowerCase()) ||
//     q.lead?.name.toLowerCase().includes(search.toLowerCase())
//   );

//   const getStatusColor = (status) => {
//     const map = {
//       Draft: "default",
//       Sent: "info",
//       "Counter Offer": "warning",
//       Revised: "secondary",
//       Approved: "success",
//       Rejected: "error",
//     };
//     return map[status] || "default";
//   };

//   if (loading) return <Box textAlign="center" mt={10}><CircularProgress /></Box>;

//   return (
//     <Box sx={{ p: 3, maxWidth: 1400, mx: "auto" }}>
//       <Paper sx={{ p: 4, borderRadius: 3 }}>
//         <Stack direction="row" justifyContent="space-between" alignItems="center" mb={4}>
//           <Typography variant="h4" fontWeight="bold" color="primary">
//             All Quotations
//           </Typography>
//           <TextField
//             size="small"
//             placeholder="Search by Quotation No / Client"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             InputProps={{
//               startAdornment: <InputAdornment position="start"><Search /></InputAdornment>,
//             }}
//           />
//         </Stack>

//         <TableContainer component={Paper} elevation={3}>
//           <Table>
//             <TableHead sx={{ bgcolor: "primary.main" }}>
//               <TableRow>
//                 <TableCell sx={{ color: "white", fontWeight: "bold" }}>Quotation No</TableCell>
//                 <TableCell sx={{ color: "white", fontWeight: "bold" }}>Client</TableCell>
//                 <TableCell sx={{ color: "white", fontWeight: "bold" }}>Date</TableCell>
//                 <TableCell sx={{ color: "white", fontWeight: "bold" }}>Grand Total</TableCell>
//                 <TableCell sx={{ color: "white", fontWeight: "bold" }}>Status</TableCell>
//                 <TableCell sx={{ color: "white", fontWeight: "bold" }}>Revision</TableCell>
//                 <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>Actions</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {filtered.map((q) => (
//                 <TableRow key={q.id} hover>
//                   <TableCell><strong>{q.quotation_no}</strong></TableCell>
//                   <TableCell>{q.lead?.name || "—"}</TableCell>
//                   <TableCell>{new Date(q.created_at).toLocaleDateString()}</TableCell>
//                   <TableCell>₹{Number(q.grand_total).toLocaleString("en-IN")}</TableCell>
//                   <TableCell>
//                     <Chip label={q.status} color={getStatusColor(q.status)} size="small" />
//                   </TableCell>
//                   <TableCell>
//                     <Chip label={q.revision || "R0"} color="primary" variant="outlined" />
//                   </TableCell>
//                   <TableCell align="center">
//                     <Tooltip title="View">
//                       <IconButton onClick={() => navigate(`/quotations/${q.id}`)}>
//                         <Visibility />
//                       </IconButton>
//                     </Tooltip>
//                     <Tooltip title="Download PDF">
//                       <IconButton href={`${API_URL}/quotations/${q.id}/pdf`} target="_blank">
//                         <Download />
//                       </IconButton>
//                     </Tooltip>
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       </Paper>
//     </Box>
//   );
// }

// src/pages/Quotation/QuotationList.jsx

import React, { useState, useEffect } from "react";
import {
  Box, Paper, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Chip, TextField, InputAdornment, Stack,
  CircularProgress, IconButton, Tooltip
} from "@mui/material";
import { Search, Download, Visibility } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";

export default function QuotationList() {
  const [quotations, setQuotations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetchQuotations();
  }, []);

  const fetchQuotations = async () => {
    try {
      const res = await api.get("/quotations");
      setQuotations(res.data.quotations || []);
    } catch (err) {
      alert("Failed to load quotations");
    } finally {
      setLoading(false);
    }
  };

  const filtered = quotations.filter(q =>
    q.quotation_no?.toLowerCase().includes(search.toLowerCase()) ||
    q.client_name?.toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return <Box textAlign="center" mt={10}><CircularProgress /></Box>;

  return (
    <Box sx={{ p: 3, maxWidth: 1400, mx: "auto" }}>
      <Paper sx={{ p: 4, borderRadius: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={4}>
          <Typography variant="h4" fontWeight="bold" color="primary">All Quotations</Typography>
          <TextField
            size="small" placeholder="Search..."
            value={search} onChange={e => setSearch(e.target.value)}
            InputProps={{ startAdornment: <InputAdornment position="start"><Search /></InputAdornment> }}
          />
        </Stack>

        <TableContainer component={Paper} elevation={3}>
          <Table>
            <TableHead sx={{ bgcolor: "primary.main" }}>
              <TableRow>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Quotation No</TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Client</TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Date</TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Amount</TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Status</TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Rev</TableCell>
                <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered.map(q => (
                <TableRow key={q.id} hover>
                  <TableCell><strong>{q.quotation_no}</strong></TableCell>
                  <TableCell>{q.client_name || "—"}</TableCell>
                  <TableCell>{new Date(q.created_at).toLocaleDateString()}</TableCell>
                  <TableCell>₹{Number(q.grand_total).toLocaleString("en-IN")}</TableCell>
                  <TableCell><Chip label={q.status || "Draft"} size="small" color={q.status === "Approved" ? "success" : "default"} /></TableCell>
                  <TableCell><Chip label={q.revision || "R0"} size="small" /></TableCell>
                  <TableCell align="center">
                    <Tooltip title="View"><IconButton onClick={() => navigate(`/quotations/${q.id}`)}><Visibility /></IconButton></Tooltip>
                    <Tooltip title="PDF"><IconButton href={`/api/quotations/${q.id}/pdf`} target="_blank"><Download /></IconButton></Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}